

















































































































































































































import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InvoiceGenerationForm from '../../forms/invoice-generation-form/invoice-generation-form.vue';

@Component({
  name: 'bpc-invoice-generation-modal',
  components: {
    'bpc-invoice-generation-form': InvoiceGenerationForm,
  },
})
export default class InvoiceGenerationModal extends Vue {
  declare $refs: {
    generateInvoiceForm: InstanceType<typeof InvoiceGenerationForm> & {
      formModel: AnyEntity;
    };
  };
  // PROPS
  @Prop({ type: String, default: 'invoice-generation-modal' }) readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String }) readonly invoiceInDraftRoute: string;
  @Prop({ type: String }) readonly invoiceInToPayRoute: string;
  @Prop({ type: String }) readonly creditNoteInDraftRoute: string;
  @Prop({ type: String }) readonly creditNoteInToPayRoute: string;
  @Prop({ type: Boolean, default: false }) readonly showProcessAllOptions: boolean;
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Number, default: 0 }) readonly totalSelectedEntities: number;

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly filterModel;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly searchAndOrder: SearchAndOrder;
  @Prop({
    type: Array,
    default() {
      return ['invoice', 'credit_note'];
    },
  })
  readonly accountingJournalsType: string[];

  // DATA

  showModalIndex = null;
  invoiceGenerationEventsError = [];
  invoiceGenerationEventsSuccess = [];
  invoiceGenerationRequestSent = false;
  isGeneratingInvoices = false;
  generateInvoiceErrors = {};
  invoiceRoute = '';
  readonly errorMessageText: string = 'global.generic.error_form_action';

  // COMPUTED
  get modalTitle() {
    return this.$t('global.modals.invoice_generation.title');
  }

  get modalBody() {
    return this.$t('global.modals.invoice_generation.body');
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    this.showModalIndex = Date.now();
    this.initInvoiceGenerationVars();
    if (this.showModal) {
      this.openModal();
    }
  }

  initInvoiceGenerationVars() {
    this.invoiceGenerationEventsError = [];
    this.invoiceGenerationEventsSuccess = [];
    this.invoiceGenerationRequestSent = false;
    this.isGeneratingInvoices = false;
    this.generateInvoiceErrors = null;
  }

  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
    this.initInvoiceGenerationVars();
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onGenerateInvoices() {
    this.invoiceGenerationEventsError = [];
    this.invoiceGenerationEventsSuccess = [];
    this.invoiceGenerationRequestSent = false;
    this.isGeneratingInvoices = false;
    this.generateInvoiceErrors = null;
    this.$bvModal.show(this.modalId);
  }

  onConfirmGenerateInvoices() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketInvoiceGenerationChannel(sessionCode);
    this.invoiceGenerationRequestSent = true;

    // JJFC TODO: extract to correspondent component
    const formModel = this.$refs?.generateInvoiceForm?.formModel;
    this.$bpcApi
      .post(basePath + '/generate', {
        ...formModel,
        orders: this.selectedItemIds,
        filters: this.filterModel,
        search_and_order: this.searchAndOrder,
        session_code: sessionCode, // TODO change this to some random code
      })
      .subscribe(
        res => {
          this.invoiceGenerationRequestSent = true;
        },
        error => {
          this.$bpcMessage.showErrorMessage({ text: this.errorMessageText });
          this.invoiceGenerationRequestSent = false;
          this.isGeneratingInvoices = false;
          this.generateInvoiceErrors = error?.response.data.errors;

          // this.$bvModal.hide('modal-generate-invoices');
        },
      );
  }
  getSessionCode() {
    return `invoice-generation-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  listenToWebsocketInvoiceGenerationChannel(sessionCode) {
    this.isGeneratingInvoices = true;
    this.$bpcEcho
      .getInvoiceGenerationChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\InvoicesGenerated', data => {
        this.isGeneratingInvoices = false;
        this.$emit('all-invoices-generated');
        // this.$bvModal.hide('modal-generate-invoices');
        this.$bpcEcho.leaveInvoiceGenerationChannel(sessionCode);
      })
      .listen('.BPC\\Accounting\\Events\\InvoiceGeneratedForContact', data => {
        this.invoiceGenerationEventsSuccess.push(data);
      })
      .listen('.BPC\\Accounting\\Events\\ErrorInOrdersGeneratingInvoicesForContact', data => {
        this.invoiceGenerationEventsError.push(data);
      })
      .listen('.BPC\\Accounting\\Events\\GlobalErrorGeneratingInvoices', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.isGeneratingInvoices = false;
        this.invoiceGenerationRequestSent = false;
        this.$bpcEcho.leaveInvoiceGenerationChannel(sessionCode);
      });
  }

  onValidationWarning(event) {
    console.log('onValidationWarning', event);
  }

  onInvoiceStatusChanged(data) {
    const type = data.type;
    const status = data.status;
    if (type === 'invoice') {
      this.invoiceRoute = status === 'draft' ? this.invoiceInDraftRoute : this.invoiceInToPayRoute;
    }
    if (type === 'credit_note') {
      this.invoiceRoute =
        status === 'draft' ? this.creditNoteInDraftRoute : this.creditNoteInToPayRoute;
    }
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
